import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { formatTariff } from '~/src/services/tariffs/formatTariff';
import type { IBundlePackage } from '~/src/services/api/api-content/cities/types';
import type { ITariffFull } from './types';

const BUNDLES_VILLAGE_URL_PART = '/village';

export const formatBundleFull = (tariff: IBundlePackage): ITariffFull => {
    const isCottage = !!tariff.salePackage2in1.is_cottage;
    const defaultColor = '#34c270';
    const reserveColor = tariff.description.color_text || COLORS.TextPrimary;
    const titleColors = [
        tariff.description.color_title_start || reserveColor,
        tariff.description.color_title_end || reserveColor,
    ];

    return ({
        ...formatTariff(tariff),
        description: tariff.description ? tariff.description.description : '',
        isCottage: isCottage,
        price: tariff.salePackage2in1.price_final,
        alias: tariff.description ? tariff.description.alias : '',
        advantages: tariff.advantages,

        analogCount: Number(tariff.salePackage2in1.analog_count),

        availableClient: Boolean(tariff.description.available_client),
        availableGuest: Boolean(tariff.description.available_guest),
        colorText: tariff.description?.color_text ? tariff.description.color_text : COLORS.TextPrimary,
        descriptionFull: tariff.description.description_full ? tariff.description.description_full : '',
        freePackets: tariff.salePackage2in1.free_packets,
        fullSaleId: tariff.salePackage2in1?.full_sale_id ?? undefined,
        hdCount: Number(tariff.salePackage2in1.hd_count),
        headingColor: tariff.description?.color ?? defaultColor,
        imageBackground: tariff.description?.image_background
            ? `url(${tariff.description.image_background})`
            : COLORS.BgMain,
        imageBackgroundWebp: tariff.description?.image_background_webp
            ? `url(${tariff.description.image_background_webp})`
            : null,
        imageInHead: false,
        includes: tariff.includes,
        isSelfOrder: !!tariff.salePackage2in1?.is_self_order,
        lineId: tariff.description.line_id,
        location: '/bundles' + (isCottage ? BUNDLES_VILLAGE_URL_PART : ''),
        priceAction: tariff.salePackage2in1.promo_price_final ? tariff.salePackage2in1.promo_price_final : null,
        priceActionPeriod: tariff.salePackage2in1.promo_duration_final
            ? tariff.salePackage2in1.promo_duration_final
            : null,
        priceConnect: Number(tariff.price_connect_internet) + Number(tariff.price_connect_tv),
        productId: tariff.sale_package_id,
        productIdForBilling: 0,
        productType: 100,
        offerContents: tariff.offerContents,
        promoDuration: tariff.salePackage2in1.promo_duration,
        promoDurationType: tariff.salePackage2in1.promo_dur_type,
        promoted: !!tariff.description?.promoted,
        salePackageId: tariff.tariff_id,
        sdCount: Number(tariff.salePackage2in1.sd_count),
        sortOnInternet: Number(tariff.description.sort_on_internet),
        speedAction: tariff.speed_bonus,
        speedActionPeriod: tariff.speed_bonus_duration,
        title: tariff.description ? (tariff.description.title || tariff.description.tariff_name) : '',
        titleColors: titleColors,
        type: 'bundles',
        weight: tariff.description.weight,
        salePackageLinks: tariff.salePackageLinks,
    });
};
